import { Input, Select, InputNumber } from "antd";
import { useState } from "react";

export const InputField = ({
  className,
  name,
  label,
  labelClassName,
  extraContent,
  placeholder,
  formItemClassName,
  newFormClassName,
  required,
  width,
  padding,
  value,
  onChange,
  type,
}) => {
  return (
    <div className={`${className}`}>
      <div className="d-flex flex-column ">
        <label
          htmlFor={name}
          className={`fs-5 fw-semibold text-white  ${labelClassName}`}
        >
          {required ? `${label}*` : label}
        </label>
        {extraContent}
        <Input
          name={name}
          id={name}
          type={type}
          className={
            newFormClassName
              ? newFormClassName
              : `bg-transparent fs-6 text-white form-item-border input-placeholder py-2 px-3 input-group ${formItemClassName}`
          }
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          style={{ width: width, padding: padding }}
        />
      </div>
    </div>
  );
};

export const SelectField = ({
  className,
  name,
  label,
  labelClassName,
  extraContent,
  placeholder,
  formItemClassName,
  option = [
    { value: "example1", label: "Example 1" },
    { value: "example2", label: "Example 2" },
  ],
}) => {
  return (
    <div className={`${className}`}>
      <div className="d-flex flex-column gap-2">
        <label
          htmlFor={name}
          className={`fs-6 fw-semibold text-white  ${labelClassName}`}
        >
          {label}
        </label>
        {extraContent}

        <CustomSelect
          placeholder={placeholder}
          options={option}
          formItemClassName={formItemClassName}
        />
      </div>
    </div>
  );
};

export const CustomSelect = ({ options, placeholder, formItemClassName }) => {
  const [selected, setSelected] = useState(placeholder);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const selectOption = (value) => {
    setSelected(value);
    setIsOpen(false);
  };

  return (
    <div className="custom-dropdown">
      <div
        className={`custom-select fs-6 custom-select  form-item-border  py-2 px-3 form-select  rounded-2 ${formItemClassName}`}
        onClick={toggleDropdown}
      >
        {selected}
      </div>
      {isOpen && (
        <div
          className="options w-100 form-item-border rounded-3 "
          style={{ background: "#090D24" }}
        >
          {options.map(({ value, label }, idx) => (
            <div
              key={idx}
              className="option"
              id={value}
              onClick={() => selectOption(label)}
            >
              {label}
            </div>
          ))}
        </div>
      )}
      <style jsx>{`
        .custom-dropdown {
          position: relative;
          display: inline-block;
        }
        .custom-select {
          background-color: transparent;
          color: #90a3be;
          padding: 10px;
          cursor: pointer;
        }
        .options {
          position: absolute;

          z-index: 100;
        }
        .option {
          padding: 10px;
          color: white;
          cursor: pointer;
        }
        .option:hover {
          background-color: rgba(255, 255, 255, 0.2); /* Highlight on hover */
        }
      `}</style>
    </div>
  );
};

export const NewSelectField = ({
  required,
  option,
  selectClassName,
  label,
  labelClassName,
  className,
  name,
  extraContent,
  search,
  placeholder,
  onChange,
  value,
}) => {
  console.log("options", option);
  // let temp = [...option];
  let temp = Array.isArray(option) ? [...option] : [];
  console.log(temp);
  temp.splice(0, 0, { label: placeholder, value: "" });
  option = temp;

  return (
    <div className={`${className}`}>
      <div className="d-flex flex-column">
        {label && (
          <label
            htmlFor={name}
            className={`fs-5 fw-semibold text-white  ${labelClassName}`}
          >
            {required ? `${label}*` : label}
          </label>
        )}
        {extraContent}
        <Select
          value={value}
          options={option}
          className={selectClassName}
          placeholder={placeholder}
          showSearch={search}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
